export default __webpack_public_path__ + "2078acb756fda599e164f4f3f80eae6b.png";